"use client";

import { useMessagePartText } from "@assistant-ui/react";
import { lazy, memo, Suspense } from "react";

/**
 * Streamdown, Shiki and KaTeX add about 800 KB of script, and the new tab opens many
 * times a day mostly without an answer on screen. So the renderer is its own chunk,
 * fetched as soon as the browser is idle after the first paint.
 */
const loadStreamdownText = () =>
  import("./streamdown-text").then((m) => ({ default: m.StreamdownText }));

const StreamdownText = lazy(loadStreamdownText);

if (typeof window !== "undefined") {
  const preload = () => void loadStreamdownText();
  if ("requestIdleCallback" in window) window.requestIdleCallback(preload, { timeout: 2000 });
  else setTimeout(preload, 200);
}

/** The part's raw text, shown for the moment before the renderer has loaded. */
function PlainText() {
  const { text } = useMessagePartText();
  return <div className="aui-md leading-relaxed whitespace-pre-wrap">{text}</div>;
}

const MarkdownTextImpl = ({ caret = true }: { caret?: boolean }) => (
  <Suspense fallback={<PlainText />}>
    <StreamdownText caret={caret} />
  </Suspense>
);

/** Markdown for a message part (an answer, or the reasoning above it). */
export const MarkdownText = memo(MarkdownTextImpl);
